import { ReactElement } from 'react';
import { Field, FieldArray, FieldArrayRenderProps, useFormikContext } from 'formik';
import Grid from '@mui/material/Grid';
import { Fab, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';

// Components
import DatePicker from 'components/DatePicker/DatePicker';

// Styles
import styles from 'components/DatePicker/DatePickerRepeater/index.module.scss';

// Types
interface IProps {
  formikKey: string;
}

export const CutoffDateRepeater = (props: IProps): ReactElement => {
  const { formikKey } = props;
  const { setFieldTouched, values } = useFormikContext();

  return (
    <FieldArray
      name={formikKey}
      render={(arrayHelpers: FieldArrayRenderProps): ReactElement => {
        return (
          <Grid container direction="column" spacing={2}>
            <Grid>
              {values?.[formikKey]?.map((_: ReactElement, idx: number) => {
                return (
                  <Grid container key={idx} spacing={3}>
                    <Grid>
                      <Field name={`${formikKey}.${idx}.year`}>
                        {({ field }) => (
                          <DatePicker field={field} format="YYYY" formikKey={formikKey} views={['year']} />
                        )}
                      </Field>
                    </Grid>
                    <Grid>
                      <Field name={`${formikKey}.${idx}.cutoffDate`}>
                        {({ field }) => <DatePicker field={field} formikKey={formikKey} timeOfDay="endOfDay" />}
                      </Field>
                      <IconButton aria-label="remove date" onClick={() => arrayHelpers.remove(idx)} size="large">
                        <ClearIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
            <Grid className={styles.container}>
              <div className={styles.add}>
                <Fab
                  aria-label="add another instance"
                  color="inherit"
                  onClick={() => {
                    arrayHelpers.push('');
                    setFieldTouched(formikKey, true);
                  }}
                  size="small"
                >
                  <AddIcon color="inherit" />
                </Fab>
                <span className={styles.text}>Add Another Instance</span>
              </div>
            </Grid>
          </Grid>
        );
      }}
    />
  );
};
